import "./UserAvatar.css";
import femaleAvatar from "../../assets/images/avatars/tnp-avatar-female.png";
import maleAvatar from "../../assets/images/avatars/tnp-avatar-male.png";
import { siteTexts } from "../i18n/siteTexts";

type UserSex = "male" | "female" | "other" | "";

type UserAvatarProps = {
  name?: string;
  sex?: UserSex;
  avatarUrl?: string;
  size?: number;
  className?: string;
  fallback?: "image" | "initials";
};

function resolveSexLabel(sex: UserSex = "") {
  const labels = siteTexts.common.userAvatar.sex;
  if (sex === "female") return labels.female;
  if (sex === "male") return labels.male;
  if (sex === "other") return labels.other;
  return labels.notInformed;
}

function resolveAvatarImage(sex: UserSex = "") {
  if (sex === "female") return femaleAvatar;
  return maleAvatar;
}

function initialsFromName(name = "") {
  const parts = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length === 0) return "?";
  const first = parts[0]?.[0] || "";
  const last = parts.length > 1 ? parts[parts.length - 1]?.[0] || "" : "";
  return `${first}${last}`.toUpperCase();
}

export default function UserAvatar({
  name = "",
  sex = "",
  avatarUrl = "",
  size = 100,
  className = "",
  fallback = "image",
}: UserAvatarProps) {
  const t = siteTexts.common.userAvatar;
  const hasCustomAvatar = Boolean(String(avatarUrl || "").trim());
  const useInitials = !hasCustomAvatar && fallback === "initials";
  const displayName = String(name || t.fallbackUser).trim() || t.fallbackUser;
  const label = hasCustomAvatar
    ? `${t.customAltPrefix} ${displayName}`
    : `${t.defaultAltPrefix} (${resolveSexLabel(sex)}) ${t.defaultAltConnector} ${displayName}`;
  const classes =
    `app-user-avatar ${useInitials ? "app-user-avatar--initials" : ""} ${className}`.trim();
  const imageSrc = hasCustomAvatar ? avatarUrl : resolveAvatarImage(sex);

  return (
    <span
      className={classes}
      aria-label={label}
      style={{ width: size, height: size }}
    >
      {useInitials ? (
        <span aria-hidden="true">{initialsFromName(name)}</span>
      ) : (
        <img src={imageSrc} alt="" aria-hidden="true" />
      )}
    </span>
  );
}
